export default {
  RETRIEVE_SALES: {
    REQUEST: "RETRIEVE_SALES.REQUEST",
    SUCCESS: "RETRIEVE_SALES.SUCCESS",
    FAILURE: "RETRIEVE_SALES.FAILURE",
  },
};
